








import { Component, Vue, Prop } from 'vue-property-decorator';
import Clock from '@/components/icons/ClockSolid.vue';
import Checked from '@/components/icons/CheckedGreen.vue';
import CircleScratched from '@/components/icons/CircleScratched.vue';

import { EActionDetailTransaction } from '@/models/performance';

@Component<IconDetailTransaction>({
  components: {
    Clock,
    Checked,
    CircleScratched
  }
})
export default class IconDetailTransaction extends Vue {
  @Prop() action!: EActionDetailTransaction;

  isActiveIconCheck(): boolean {
    return (
      this.action === EActionDetailTransaction.CREATE ||
      this.action === EActionDetailTransaction.CLEAR ||
      this.action === EActionDetailTransaction.RELEASE ||
      this.action === EActionDetailTransaction.CLAIM ||
      this.action === EActionDetailTransaction.RELEASE_SOON
    );
  }

  isActiveIconClock(): boolean {
    return (
      this.action === EActionDetailTransaction.PROCESSING_PAYMENT ||
      this.action === EActionDetailTransaction.FUTURE_RELEASE ||
      this.action === EActionDetailTransaction.WAITING_RELEASE
    );
  }

  isActiveCircleScratched(): boolean {
    return (
      this.action === EActionDetailTransaction.TOTAL_REFUND ||
      this.action === EActionDetailTransaction.PARTIAL_REFUND
    );
  }
}
